import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Defer non-critical perf monitor until the browser is idle
const idle =
  (window as any).requestIdleCallback ||
  ((cb: () => void) => setTimeout(cb, 1500));
idle(() => {
  import("./lib/performance-monitor").then((m) => m.initPerformanceMonitor());
});
